import React, { useState, useCallback } from 'react';
import { IVerifyDomainDialogResult } from 'types/dialogs';
import VerifyDomainDialog from './VerifyDomainDialog';

const useVerifyDomainDialog = () => {
	const [verifyDomainDialogJsx, setVerifyDomainDialogJsx] =
		useState<React.JSX.Element | null>(null);

	const openVerifyDomainDialog = useCallback(
		(domain: string) =>
			new Promise<IVerifyDomainDialogResult>((resolve) => {
				setVerifyDomainDialogJsx(
					<VerifyDomainDialog
						domain={domain}
						onClose={(res: IVerifyDomainDialogResult) => {
							setVerifyDomainDialogJsx(null);
							resolve(res);
						}}
					/>
				);
			}),
		[]
	);

	return {
		verifyDomainDialogJsx,
		openVerifyDomainDialog
	};
};

export default useVerifyDomainDialog;
